import { typedMoneyProblem } from "./typed-money";

export function typedPrice(text: string): number | null {
  if (text.trim() === "" || typedMoneyProblem(text) !== null) return null;
  return Number(text);
}
